import { axiosInstance } from '@services/base-service';
import { buildFilesFormData } from '@helpers/service';

const coreOperationsUri = '/merchant/bff/core-operations';

export const getDocumentStatus = (docNumber, docType) =>
  axiosInstance
    .getInstance()
    .get(`${coreOperationsUri}/documentation_status/${docType}/${docNumber}`);

export const uploadMerchantDocument = (files, data) =>
  axiosInstance
    .getInstance()
    .patch(
      `${coreOperationsUri}/documentation/${data.doc_type}/${data.doc_number}`,
      buildFilesFormData(files, data.document_type),
      { headers: { 'content-type': 'multipart/form-data' } }
    );

export const getDownloadDocument = (type) =>
  axiosInstance.getInstance().post(`${coreOperationsUri}/image`, {
    payload: {
      type,
    },
  });
